import React, {
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import * as currentPageAction from '../../../store/actions/currentPageAction';
import Translator from '../../../layout/components/helpers/Translator';
import Sidebar from '../../../layout/Sidebar/Sidebar';
import AppLink from '../../../routing/helpers/AppLink';
import EmailNotificationSettings from '../../../layout/screenSpecifics/Modules/LegalCompliance/EmailNotifications/EmailNotificationSettings';

const LegalComplianceModuleConfigurationScreen = () => {
  const dispatch = useDispatch();
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  useEffect(() => () => {
    dispatch(currentPageAction.empty());
  }, []);
  return (
    <div>
      <BreadcrumbHandler
        paths={
              [
                { name: ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="settings" />) },
              ]
           }
      />
      <Sidebar>
        <img src={auth.user?.client?.logoUrl} className="img-fluid" alt={auth.user?.client?.name} title={auth.user?.client?.name} />
        <Accordion>
          <ul>
            <li>
              <AppLink
                path="user_module_legalCompliance_home"
                params={{
                  moduleBridgeHex, page: 0, filterHex: 0,
                }}
                className="sidebar-element"
              >
                <AppRemixIcon icon="arrow-go-back-line" className="sidebar-icon" noVariants />
                {' '}
                <span className="sb-title">
                  <Translator file="user" name="user.password.forgotten.remember.back" />
                </span>
              </AppLink>
            </li>
            <li className="divider" />
          </ul>
        </Accordion>
      </Sidebar>
      <div className="p-2">
        <AppCard header={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="notifications.settings" />)}>
          <EmailNotificationSettings
            type="ModuleBridge"
            element={moduleBridgeHex}
          />
        </AppCard>
      </div>
    </div>
  );
};

export default LegalComplianceModuleConfigurationScreen;
